<template>
  <header id="demo--cta-header" :class="{'live-demo-cta': type === 'live-demo'}">
    <aha-logo
      width="132"
      height="30"
      class="inline-block fixed left-4 cursor-pointer logo-cta"
      :use-default-color="false"
      v-if="type === 'live-demo'"
      @click="goToHomePage()"
    />

    <p v-if="type === 'live-demo'" class="hidden sm:inline">
      {{ $i18nPresenter.t('Sign up for free to use this with your audience') }}
      <aha-icon
        viewBox="0 0 10 16"
        width="6"
        height="10"
        name="chevron-right"
        class="ml-3 hidden sm:inline"
      />
    </p>
    <p class="hidden sm:inline" v-else>
      {{ $i18nPresenter.t("You're in Demo Mode.") }}&nbsp;
    </p>
    <span class="text-cta-signup" v-if="type !== 'live-demo'">
      {{ $i18nPresenter.t('Sign up for free to save your work') }}
      <aha-icon
        viewBox="0 0 10 16"
        width="6"
        height="10"
        name="chevron-right"
        class="ml-3 hidden sm:inline"
      />
    </span>
    <aha-button
      variant="warning"
      @click.prevent="goToSignUpPage()"
      class="pt-1 pb-0.5 ml-3 mb-1"
    >
      {{ $i18nPresenter.t('SIGN UP') }}
    </aha-button>
  </header>
</template>

<script>
import { mapState } from 'vuex'
import Util from '@/util'
import constants from '@/constant'
import config from '@/config'

const { eventCategories } = constants

export default {
  props: {
    type: {
      type: String,
      default: 'demo',
    },
  },
  computed: {
    ...mapState({
      isReferPublicTemplate: (state) => state.isReferPublicTemplate,
    }),
  },
  methods: {
    goToHomePage() {
      Util.mixpanelTracking('Live Demo', 'Live Demo > Click Logo')
      setTimeout(() => {
        window.location.href = 'https://ahaslides.com'
      }, 500)
    },
    goToSignUpPage() {
      if (this.type === 'live-demo') {
        Util.mixpanelTracking('Live Demo', 'Live Demo > Click Sign up')
        setTimeout(() => {
          window.location.href = `${config.presenterDomain}/pages/register?source=live-demo&medium=live-demo&campaign=live-demo&content=header`
        }, 500)
      } else {
        Util.mixpanelTracking(eventCategories.PRESENTATION_EDITOR, 'Demo Mode > Click Sign up CTA')
        this.$router.push({
          name: 'Register',
          query: {
            source: 'demo',
            medium: 'demo',
            campaign: 'demo',
            content: 'header',
          },
        })
      }
      if (this.isReferPublicTemplate) {
        Util.mixpanelTracking('Rss > Public template > Demo', 'Sign up')
      }
    },
  },
}
</script>

<style lang="scss" scoped>
#demo--cta-header {
  @apply w-full fixed top-0 left-0 h-10 text-center;
  @apply flex justify-center items-center text-base-0;
  background: linear-gradient(90deg, #6A1EBB 0.29%, #3E6EB6 100%);
}

.logo-cta {
  top: 10px;
}

@media (max-width: 800px) {
  #demo--cta-header.live-demo-cta {
    padding-left: 150px;
    justify-content: end;
    padding-right: 16px;
  }
}

</style>
